import { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Main from './views/Main';
import CreateSchedule from './views/Admin/CreateSchedule';
import Fix from './views/Admin/Fix';
import Book from './views/Book';
import ClaimBooking from './views/ClaimBooking';
import Header from './views/Header';
import PrivateRoute from './components/PrivateRoute';
import ComingSoon from './components/ComingSoon';
import { useUserContext } from './hooks/userHook';
import PromptInstall from './components/PromptInstall';
import { privilegedUser } from './utils/user';
import animatedLogo from './images/animated-fullimpact-v1-1.gif';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
  const [headless, setHeadless] = useState<boolean>(false);
  const { user, loading, loginAuth0, logoutUser } = useUserContext();

  const isHeadless = !!(new URLSearchParams(useLocation().search)).get('headless') || (window.self !== window.top);
  const autoLogin = !!(new URLSearchParams(useLocation().search)).get('autoLogin');

  useEffect(() => {
    console.log('AUTOLOGIN: ', autoLogin);
    setHeadless(isHeadless);
  }, []);
  // // NOT READY FOR PRIME TIME!
  // useEffect(() => {
  //   if (isHeadless) {
  //     autoLogin
  //       ? !user && loginAuth0()
  //       : user && logoutUser();
  //   }
  // }, [user]);

  const privileged = privilegedUser(user);

  return (
    <div id="schedule-app-container" className="pb-2">
      {!!!headless && <Header />}
      <main className="container pb-4">
        {loading
          ? (
            <div
              className="d-flex flex-column justify-content-center align-items-center"
              style={{
                height: '100vh',
                width: '100vw',
                position: 'absolute',
                top: 0,
                left: 0
              }}
            >
              <img className="loading-logo" src={animatedLogo} alt="Full Impact Loading..." />
              <span className="flicker-animation">Loading</span>
            </div>
          )
          : (
            <>
              <Routes>
                <Route
                  path="/create"
                  element={
                    <PrivateRoute
                      component={CreateSchedule}
                      authenticated={privileged}
                    />
                  }
                />

                <Route
                  path="/fix"
                  element={
                    <PrivateRoute
                      component={Fix}
                      authenticated={privileged}
                    />
                  }
                />

                <Route path="/book" element={<Book />} />
                <Route path="/book/:bookDate" element={<Book />} />

                <Route path="/coming-soon" element={<ComingSoon />} />

                <Route path="/claim/:bookingId" element={<ClaimBooking />} />

                <Route path="/*" element={<Main />} />
              </Routes>
            </>
          )
        }
        {user?.email && <small style={{ fontSize: '50%' }} className='fullimpact-grey pt-4 d-block'>{`Logged in: ${user.email}`}</small>}
      </main>
      <PromptInstall />
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
        theme="colored"
      />
    </div>
  );
};

export default App;